import React from 'react';
import { ArcButton, ArcStack } from '@src/core/ui';
import ToggleCollapseView from '@src/features/drone/components/toggle-collapse-view';
import { ReactComponent as ReelUpIcon } from '@src/assets/icons/reel-up.svg';
import { ReactComponent as ReelDownIcon } from '@src/assets/icons/reel-down.svg';
import { ReactComponent as LockIcon } from '@src/assets/icons/lock.svg';
import { ReactComponent as UnlockIcon } from '@src/assets/icons/unlock.svg';
import StopIcon from '@mui/icons-material/Stop';
import { EmergencyStatusEnum } from '@src/features/order/entities';
import { useConfirm } from '@src/core/controllers/confirm-controller/hooks';
import { toast } from 'react-toastify';
import { WinchControlProps } from './types';
import { useSendCommandMutation } from '@src/features/drone/redux';

export const WinchControl: React.FC<WinchControlProps> = (props) => {
  const { droneId } = props;
  const { confirm } = useConfirm();
  const [ sendCommand ] = useSendCommandMutation();
  const onSend = async (command: EmergencyStatusEnum) => {
    if (command === EmergencyStatusEnum.LOCK) {
      const confirmed = await confirm(
        'Ensure the payload is secured.',
        'Confirm Winch lock?'
      );
      if (!confirmed) {
        return;
      }
    }
    
    if (command === EmergencyStatusEnum.UNLOCK) {
      const confirmed = await confirm(
        'Verify that releasing is safe.',
        'Confirm Winch unlock?'
      );
      if (!confirmed) {
        return;
      }
    }

    if (command === EmergencyStatusEnum.STOP) {
      const confirmed = await confirm(
        'The drone will stop and hover in place until further command.',
        'Confirm Stop?'
      );
      if (!confirmed) {
        return;
      }
    }
    if (command === EmergencyStatusEnum.REEL_DOWN) {
      const confirmed = await confirm(
        'Ensure the drop zone is clear.',
        'Confirm Winch down?'
      );
      if (!confirmed) {
        return;
      }
    }

    if (command === EmergencyStatusEnum.REEL_UP) {
      const confirmed = await confirm(
        'Make sure the path above is unobstructed.',
        'Confirm Winch up?'
      );
      if (!confirmed) {
        return;
      }
    }
    
    sendCommand({ droneId, command }).then(() => {
      toast.success(`${command} SUCCESS TEXT`);
    });
  };

  return (
    <ArcStack>
      <ToggleCollapseView label='WINCH CONTROLS'>
        <ArcStack direction='row' spacing={1} marginTop={1}>  
          <ArcButton.ghost startIcon={<LockIcon />} fullWidth onClick={() => onSend(EmergencyStatusEnum.LOCK)}>
            LOCK
          </ArcButton.ghost>
          <ArcButton.ghost startIcon={<UnlockIcon />} fullWidth onClick={() => onSend(EmergencyStatusEnum.UNLOCK)}>
            UNLOCK
          </ArcButton.ghost>
          <ArcButton.ghost startIcon={<StopIcon />} fullWidth onClick={() => onSend(EmergencyStatusEnum.STOP)}>
            STOP
          </ArcButton.ghost>
        </ArcStack>
        <ArcStack direction='row' spacing={1} marginTop={1}>  
          <ArcButton.ghost fullWidth startIcon={<ReelDownIcon />} onClick={() => onSend(EmergencyStatusEnum.REEL_DOWN)}>REEL DOWN</ArcButton.ghost>
          <ArcButton.ghost fullWidth startIcon={<ReelUpIcon />} onClick={() => onSend(EmergencyStatusEnum.REEL_UP)}>REEL UP</ArcButton.ghost>
        </ArcStack>
      </ToggleCollapseView>
    </ArcStack>
  );
};